import React from 'react';
import trendsChartPlaceholder from 'assets/images/timeline_details/trends_chart_placeholder.png';
import { FormattedMessage } from 'react-intl';

const NoAvailableSetupsChartsPlaceholder = () => {
  return (
    <div className="TrendsChartPlaceholder">
      <div className="TrendsChartPlaceholder__image">
        <img src={trendsChartPlaceholder} alt="placeholder_image" />
      </div>
      <span className="TrendsChartPlaceholder__no-data">
        <FormattedMessage id="TimelineDetails.TrendsTimeline.TrendsChartPlaceholder.noAvailableView" />
      </span>
    </div>
  );
};

export default NoAvailableSetupsChartsPlaceholder;
